// src/Pages/FAQ.js
import React from "react";
import { Link } from "react-router-dom";
import "./FAQ_pages/FAQ.css";
export default function FAQ() {
  return (
    <div className="intro-container faq-page">
      <h2 className="faq-title">Instructions and FAQ</h2>

      <div className="steps-container">
        <Link to="/faq/events" className="step">
          <h3>Gathering Host Instructions</h3>
        </Link>
        <Link to="/faq/vendors" className="step">
          <h3>Vendor Instructions</h3>
        </Link>
        <Link to="/faq/artists" className="step">
          <h3>Artist Instructions</h3>
        </Link>
        <Link to="/faq/referral" className="step">
          <h3>Referral Instructions</h3>
        </Link>
      </div>

      <div className="faq-section">
        <h3 className="faq-title">General Questions</h3>

        <div className="faq-item">
          <div className="faq-question">
            What is <strong>itiniri</strong>?
          </div>
          <div className="faq-answer">
            itiniri is an Event Management Platform and mobile application that
            provides a clean and easy-to-use interface for events of all kinds.
            Our website allows Event Managers, Vendors and Artists to enter
            their event information, and the app displays that information to
            attendees in a virtual program.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            How do I create and publish my event?
          </div>
          <div className="faq-answer">
            See the <Link to="/faq/events">Gathering Host Instructions</Link>{" "}
            section.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">How do I add and manage vendors?</div>
          <div className="faq-answer">
            Refer to <Link to="/faq/vendors">Vendor Instructions</Link>.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">How do I create an artist profile?</div>
          <div className="faq-answer">
            See <Link to="/faq/artists">Artist Instructions</Link>.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">How do I create a vendor profile?</div>
          <div className="faq-answer">
            See <Link to="/faq/vendors">Vendor Instructions</Link>.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            How do I add Vendors and Artists to my event?
          </div>
          <div className="faq-answer">
            In the <strong>Vendors</strong> or <strong>Artists</strong> tab of
            your Event Dashboard, you will see your unique Gathering Reference
            ID. Share that with your Vendors and Artists, and they can use it to
            add themselved to your event with their own customized profiles. As
            Event Host, you don't have to enter any information for Artists or
            Vendors.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            How do I remove Vendors or Artists from my event?
          </div>
          <div className="faq-answer">
            If you want to remove a Vendor or Artist from your event for any
            reason, you can do so inside the <strong>Vendors</strong> or{" "}
            <strong>Artists</strong> tabs, respectively.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            How do I remove an Artist from an event in the schedule?
          </div>
          <div className="faq-answer">
            Once linked to your Gathering, an Artist can "claim" an event to
            link their profile to the event they are involved with. If multiple
            artists are linked to a single event, you can customize the order in
            the Schedule tab by clicking the Event. If you want to remove an
            Artist from an Event, just click the <strong>x</strong> button next
            to their name in the Event.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            Is there a limit of the number of Events I can create?
          </div>
          <div className="faq-answer">
            There is currently a limit of three Events per user until one Event
            is paid for. Once you have submitted payment for one Event, you can
            create as many Events as you want.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            Can other members of my team also log in and make changes?
          </div>
          <div className="faq-answer">
            Yes! If you've created the Event, you are the Event Host. However,
            you can add Team Members via their email in the{" "}
            <strong>Team</strong> tab of your Event Dashboard. Then, they can
            make changes and publish announcements.
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            How does the referral program work?
          </div>
          <div className="faq-answer">
            Details are in <Link to="/faq/referral">Referral Instructions</Link>
            .
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            Can I update my event details after publishing?
          </div>
          <div className="faq-answer">
            Yes - all changes made on the website will be automatically
            displayed on the app. No need to re-publish your event!
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">How do I reset my password?</div>
          <div className="faq-answer">
            Enter your account email in{" "}
            <Link to="http://itiniri.app/auth">our login page</Link> and click{" "}
            <strong>Forgot password.</strong>
          </div>
        </div>

        <div className="faq-item">
          <div className="faq-question">
            Is there a limit on vendors or artists?
          </div>
          <div className="faq-answer">No—add as many as needed.</div>
        </div>

        <div className="faq-item">
          <div className="faq-question">How do I contact support?</div>
          <div className="faq-answer">
            Submit a ticket or chat via our <Link to="/support">Support</Link>{" "}
            page.
          </div>
        </div>
      </div>
    </div>
  );
}
